import { useEffect } from "react"

import { ClaimRewardsModalBody } from "#/shared/components/modals/ClaimRewards"
import { ComponentStepProps } from "#/ui/Modal"

export default function ClaimingRewards({
  onClickContinue,
  onClose,
  ...restProps
}: ComponentStepProps) {
  useEffect(() => {
    // TODO: Temporary solution. Create a hook to claim rewards.
    const timeout = setTimeout(() => {
      onClickContinue()
    }, 3_000)

    return () => {
      clearTimeout(timeout)
    }
  }, [onClickContinue])

  // TODO: Fetch points or pass as a props.
  const points = "3000"

  return (
    <ClaimRewardsModalBody
      onClickContinue={onClickContinue}
      onClose={onClose}
      totalMats={points}
      isClaiming
      {...restProps}
    />
  )
}
